import { useMutation } from "@tanstack/react-query"
import fetchData from "../fetcher"
import { UserResponse } from "../use-me/types"
import { UpdateMePayload, UpdateProfileRequest } from "./types"
import { useUserStore } from "@/store"

const toUpdateMePayload = (
    existing: Partial<UserResponse["data"]>,
    patch: UpdateProfileRequest
): UpdateMePayload => ({
    salutation: patch.salutation ?? existing.salutation ?? "",
    firstName: patch.firstName ?? existing.firstName ?? "",
    lastName: patch.lastName ?? existing.lastName ?? "",
    phoneNumber: patch.phoneNumber ?? existing.phoneNumber ?? "",
    language: patch.language ?? existing.language ?? "",
    profileImageUrl: patch.profileImageUrl ?? existing.profileImageUrl ?? "",
    attributes: patch.attributes ?? existing.attributes ?? {},
})

export const updateIamMe = async (patch: UpdateProfileRequest) => {
    const meResponse = await fetchData<UserResponse>("/iam/v4/iam/me", { method: "GET" })
    const existing = meResponse?.data || (meResponse as unknown as UserResponse["data"]) || {}
    const body = toUpdateMePayload(existing, patch)

    const result = await fetchData<UserResponse>("/iam/v4/iam/me", { method: "POST", body })
    const updated = result?.data || ({ ...existing, ...body } as UserResponse["data"])
    if (updated?.itemId) {
        useUserStore.getState().setUser(updated)
    }
    return result
}

export const useUpdateProfile = () => {
    const { mutate: updateMe, mutateAsync: updateMeAsync, isPending: isUpdateMePending, isError } = useMutation({
        mutationKey: ["update-profile"],
        mutationFn: (data: UpdateProfileRequest) => updateIamMe(data),
    })

    return {
        updateMe,
        updateMeAsync,
        isUpdateMePending,
        isError
    }
}
